import service from '.';

export interface IPlatformItem {
  platform: string;
  name: string;
  defaultCheck: boolean;
  color: string;
  isSpider: boolean;
}

export enum ECompanyFieldOptionType {
  Combo = 'COMBO',
  Provider = 'PROVIDER',
  Industry = 'INDUSTRY',
  CustomerType = 'CUSTOMER_TYPE',
}

export interface CompanyFieldOption {
  id?: string | number;
  value?: string | number;
  industryId?: string | number;
  label?: string;
  name?: string;
  industriy?: string;
  industry?: string;
}

export const commonApi = {
  /** 获取平台列表 */
  getPlatformList: () => {
    return service.get<IPlatformItem[]>('/common/platform');
  },
  // 获取文章分类
  getArticleCategories: () => {
    return service.get<
      {
        defaultCount: string;
        categoryName: string;
        name: string
      }[]
    >('/common/articles');
  },
  /** 获取公司字段选项 */
  companyFieldOptions: (type: ECompanyFieldOptionType) => {
    return service.get<CompanyFieldOption[]>(`/common/company-field-options/${type}`);
  },
};
